import { CheckBox } from 'entities/ChekBox'
import { languageOptions } from './languageOptions'
import { LanguagePickerContainer } from './styled'
import { useConfigStore } from 'shared/store/configSlice'
import { useEffect } from 'react'
import { useBranchStore } from 'shared/store/branchesSlice'
import { AvailableLanguagesType } from 'shared/store/types'
import { FormLabel } from '@mui/material'

export const LanguagePicker = () => {
  const branchId = useBranchStore().branchId
  const isConfigLoaded = useConfigStore().isConfigLoaded
  const languagesConfig = useConfigStore().config?.languagesConfig
  console.log('🚀 ~ languagesConfig:', languagesConfig)
  const updateLanguage = useConfigStore().updateLanguagesConfig

  useEffect(() => {
    if (isConfigLoaded && !languagesConfig?.length && !!branchId) {
      updateLanguage('default')
    }
  }, [languagesConfig, isConfigLoaded, branchId])

  return (
    <>
      <FormLabel>Select which languages will be available for users in the app.</FormLabel>
      <LanguagePickerContainer>
        {languageOptions?.map(language => {
          return (
            <CheckBox
              checked={languagesConfig?.includes(language.value as AvailableLanguagesType)}
              handleChange={() => updateLanguage(language.value as AvailableLanguagesType)}
              label={language.label}
            />
          )
        })}
      </LanguagePickerContainer>
    </>
  )
}
